import { Award, Building2, GraduationCap, TrendingUp } from "lucide-react";
import { MELISSA_PHOTO } from "../data";
import { Reveal } from "./Reveal";

const HIGHLIGHTS = [
  { icon: TrendingUp, label: "Over a decade in real estate" },
  { icon: Award, label: "Top-rated Zillow Realtor" },
  { icon: Building2, label: "Foreclosures and investment properties specialist" },
  { icon: GraduationCap, label: "Holds a teaching credential" }
];

export const Bio = () => (
  <section id="bio" data-testid="bio-section" className="py-24 md:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <Reveal className="lg:col-span-5">
        <div className="relative">
          <div className="absolute -top-5 -left-5 w-full h-full border border-gold/40 hidden sm:block" />
          <img
            src={MELISSA_PHOTO}
            alt="Melissa O'Donnell, Realtor"
            data-testid="bio-photo"
            className="relative w-full aspect-[3/4] object-cover object-top"
          />
        </div>
      </Reveal>

      <div className="lg:col-span-7">
        <Reveal>
          <p className="eyebrow text-gold mb-4">About Melissa</p>
          <h2 className="font-heading font-light text-4xl sm:text-5xl tracking-tight leading-tight">
            Melissa O'Donnell
          </h2>
          <p className="text-[#52525b] font-light text-lg mt-6 leading-relaxed max-w-2xl">
            With over a decade of experience in Southern California real estate, Melissa O'Donnell
            has built a reputation as a trusted, top-rated Zillow Realtor. Her deep expertise spans
            foreclosures and investment properties, and as a credentialed educator she brings clarity,
            patience, and strategy to every client — whether you're buying your first home or building
            a portfolio.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-px bg-black/5 mt-10">
          {HIGHLIGHTS.map((h, i) => (
            <Reveal key={h.label} delay={i * 0.08} className="bg-white">
              <div className="flex items-start gap-4 p-6" data-testid={`bio-highlight-${i}`}>
                <h.icon className="text-gold shrink-0 mt-1" size={22} strokeWidth={1.5} />
                <span className="font-light text-[#0a0a0a]">{h.label}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-10 pt-8 border-t border-black/5 flex flex-wrap items-center gap-x-8 gap-y-2">
            <span className="font-light text-[#52525b]">Brokered by <span className="text-[#0a0a0a]">Real Broker</span></span>
            <span className="font-mono text-xs text-[#a1a1aa]">DRE# 01810851</span>
          </div>
          <a
            href="#quiz"
            data-testid="bio-cta"
            className="inline-flex items-center gap-2 bg-[#0a0a0a] text-white text-sm px-8 py-4 mt-8 hover:bg-[#27272a] transition-colors"
          >
            Work With Melissa
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
